export default "__VITE_ASSET__07f290a5__"